  gsap.to('.pill-nav', {
    scrollTrigger: {
      trigger: '.logo-trigger',
      start: 'top bottom', 
      //end: 'bottom top',
      end: 'bottom -=800',
      toggleClass: {targets: '.pill-nav', className: 'sticky'},
    }
  });


// Function to add event listeners to nav links for click events
function setupNavLinkClicks() {
  document.querySelectorAll('.pill-nav a').forEach(link => {
    link.addEventListener('click', function(event) {
      clearActiveNav(); // Remove 'active' class from all nav links
      this.classList.add('active'); // Add 'active' class to the clicked link
    });
  });
}

// Call the function to set up click event listeners on nav links
setupNavLinkClicks();

gsap.registerPlugin(ScrollTrigger);

// Function to clear 'active' class from all nav links
function clearActiveNav() {
  document.querySelectorAll('.pill-nav a').forEach(link => {
    link.classList.remove('active');
  });
}

// Set up click event listeners on nav links
function setupNavLinkClicks() {
  document.querySelectorAll('.pill-nav a').forEach(link => {
    link.addEventListener('click', function(event) {
    clearActiveNav(); // Remove 'active' class from all nav links
    this.classList.add('active'); // Add 'active' class to the clicked link
    });
  });
}

// Call the function to set up click event listeners on nav links
setupNavLinkClicks();

// About Section Trigger
ScrollTrigger.create({
  trigger: '.domestic-retailers',
  start: 'top center',  // Adjust as needed
  end: 'bottom center',  // Adjust as needed
  onEnter: () => {
    clearActiveNav();
    document.querySelector('.nav-usa').classList.add('active');
  },
  onLeaveBack: () => {
    document.querySelector('.nav-usa').classList.remove('active');
  },
  onEnterBack: () => {  // Trigger when the section reappears from the top
    clearActiveNav();
    document.querySelector('.nav-usa').classList.add('active');
  }
});


// Ethics Section Trigger
ScrollTrigger.create({
  trigger: '.international-retailers',
  start: 'top center', // Adjust as needed
  end: 'bottom center', // Adjust as needed
  onEnter: () => {
    clearActiveNav();
    document.querySelector('.nav-international').classList.add('active');
  },
  onLeaveBack: () => {
    document.querySelector('.nav-international').classList.remove('active');
  }
});